
export const PUBLIC_HOST = "localhost";
export const PUBLIC_PORT = "8000";